import type { ProfileLanguage, ProfileMediaType } from "../../types/profile";

/**
 * JP / EN の二言語フィールドから、現在の表示言語に応じた値を選ぶ。
 * EN が空のときは JP にフォールバックする。
 */
export const pickLang = (
  jp: string | null | undefined,
  en: string | null | undefined,
  language: ProfileLanguage,
): string => {
  if (language === "EN") {
    return (en && en.trim()) || jp || "";
  }
  return jp || "";
};

const EXT_TO_TYPE: Record<string, ProfileMediaType> = {
  jpg: "image",
  jpeg: "image",
  png: "image",
  gif: "image",
  webp: "image",
  avif: "image",
  svg: "image",
  mp4: "video",
  webm: "video",
  mov: "video",
  m3u8: "video",
  mp3: "audio",
  wav: "audio",
  aac: "audio",
  m4a: "audio",
  ogg: "audio",
  flac: "audio",
  pdf: "pdf",
};

/** URL の拡張子からメディア種別を推定する（不明時は null）。 */
export const getMediaTypeFromUrl = (
  url: string | null | undefined,
): ProfileMediaType | null => {
  if (!url) return null;
  const clean = url.split("?")[0].split("#")[0];
  const ext = clean.split(".").pop()?.toLowerCase();
  if (!ext) return null;
  return EXT_TO_TYPE[ext] ?? null;
};
